<template>
  <component :is="loadingType"></component>
</template>

<script>
import AvatarTwoLine from "./components/AvatarTwoLine.vue";
import AvatarThreeLine from "./components/AvatarThreeLine.vue";
import OneLine from "./components/OneLine.vue";
import TwoLine from "./components/TwoLine.vue";
import CardList from "./components/CardList.vue";
import CardShow from "./components/CardShow.vue";
export default {
  components: {
    AvatarTwoLine,
    AvatarThreeLine,
    OneLine,
    TwoLine,
    CardList,
    CardShow
  },
  props: {
    loadingType: {
      type: String,
      default: "avatar-two-line"
    }
  }
};
</script>
